/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { ToastContainer, Zoom, toast } from "react-toastify";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";

const AddMenu = ({ refetch }) => {
  const dispatch = useDispatch;
  const [isLoading, setIsLoading] = useState();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  //get api http://192.168.0.173/kyamch_ctms_backend_qa/api/moduleSetup

  const onSubmit = (data, e) => {
    alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("module_name", data.module_name);
    formData.append("short_name", data.short_name);
    formData.append("module_name_bn", "bn");
    formData.append("category", data.category);
    formData.append("sl_no", data.sl_no);
    formData.append("active_fg", data.active_fg);
    fetch(
      // `http://192.168.0.173/kyamch_ctms_backend_qa/api/storemoduleSetup`,
      `${process.env.REACT_APP_API_URL}/api/storemoduleSetup`,
      // `http://192.168.0.173/kyamch_ctms_backend_qa/api/createVoluntary`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        // console.log(res);
        return res.json();
      })
      .then((data) => {
        // console.log("data", data);
        if (data.success === true) {
          refetch();
          dispatch(handleAddClose());
          // console.log("111111");
        } else if (data.duplicate === true) {
          toast.error("Module Name is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <TextField
          size="small"
          fullWidth
          label="Module Name*"
          variant="outlined"
          {...register("module_name", {
            required: true,
            // pattern: /^[a-zA-Z]+$/,
          })}
        />
        {errors?.module_name?.type === "required" && (
          <ErrorMessage>Module name is required*</ErrorMessage>
        )}
        {errors?.module_name?.type === "pattern" && (
          <ErrorMessage>Should not allow inserting any symbol</ErrorMessage>
        )}
      </Box>

      <Box px="20px">
        <TextField
          size="small"
          fullWidth
          label="Short Name"
          variant="outlined"
          {...register("short_name", {
            // required: true,
          })}
        />
      </Box>
      <Box p="20px">
        <TextField
          size="small"
          fullWidth
          label="Category"
          variant="outlined"
          {...register("category", {
            // required: true,
            // pattern: /^[a-zA-Z]+$/,
          })}
        />
      </Box>
      <Box px="20px">
        <TextField
          size="small"
          fullWidth
          label="Serial No"
          variant="outlined"
          {...register("sl_no", {
            // required: true,
            // pattern: /^[a-zA-Z]+$/,
          })}
        />
      </Box>

      <Box p="20px">
        <TextField
          select
          defaultValue="Y"
          size="small"
          fullWidth
          label="Active Status"
          variant="outlined"
          {...register("active_fg", {
            // required: true
          })}
        >
          <MenuItem value="Y">Active</MenuItem>
          <MenuItem value="N">Inactive</MenuItem>
        </TextField>
        {errors?.active_status?.type === "required" && (
          <ErrorMessage>Active status is required*</ErrorMessage>
        )}
      </Box>
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        <ThemButton
          style={
            {
              //   width: "30%",
            }
          }
          type="submit"
        >
          Add
        </ThemButton>
      </Box>

      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />

      {/* <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
          {isLoading ? (
            <ThemButton
              style={
                {
                }
              }
              type="submit"
            >
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton
              style={
                {
                  
                }
              }
              type="submit"
            >
              Add User Level
            </ThemButton>
          )}
  
          <ToastContainer
            autoClose={2000}
            limit={1}
            transition={Zoom}
            toastStyle={{ border: "2px solid crimson" }}
          />
        </Box> */}
    </form>
  );
};

export default AddMenu;

// {
//   "module_name": "asadullah",
//   "short_name": "s",
//   "module_name_bn": "bangla",
//   "category": "1",
//   "sl_no": 1,
//   "active_fg": "Y"
// }
// (12:35:31 PM) 192.168.0.97/kyamch_ctms_backend/api/storemoduleSetup
// (12:36:47 PM) get : 192.168.0.97/kyamch_ctms_backend/api/moduleSetup
